import React, { useState } from "react";
import { ReactComponent as CloseIcon } from "../../../themes/Icons/close_icon.svg";
import PropTypes, { func } from "prop-types";
import { GeneralStyle, FormCard, SectionWrapper } from "./FormsCreation.styled";
import { Row, Col } from "react-bootstrap";
import { theme as themeConfig } from "../../../themes/themes";
import NotificationManager from "react-notifications/lib/NotificationManager";

const FormsCreation = ({ setFormTrigger, handleFormCreation }) => {
  const [formName, setFormName] = useState("");
  const [formDesc, setFormDesc] = useState("");

  const handleCreate = () => {
    if (formName && formDesc) {
      handleFormCreation({
        formName,
        formDesc,
      });
    } else {
      NotificationManager.warning(
        "Please enter the form name and description",
        "",
        5000
      );
    }
  };

  return (
    <>
      <GeneralStyle>
        <FormCard>
          <SectionWrapper>
            <h1>Create Form</h1>
            <CloseIcon onClick={() => setFormTrigger("")} />
            <hr />
          </SectionWrapper>
          <SectionWrapper>
            <Row>
              <Col md="12">
                <label>Form Name</label>&nbsp;
                <span style={{ color: themeConfig.status.error }}>*</span>
              </Col>
              <Col md="12">
                <input
                  type="text"
                  value={formName}
                  onChange={(e) => setFormName(e.target.value)}
                  required
                  placeholder="Please enter a name"
                />
              </Col>
            </Row>
          </SectionWrapper>
          <SectionWrapper>
            <Row>
              <Col md="12">
                <label>Form Description</label>&nbsp;
                <span style={{ color: themeConfig.status.error }}>*</span>
              </Col>
              <Col md="12">
                <input
                  type="text"
                  value={formDesc}
                  onChange={(e) => setFormDesc(e.target.value)}
                  required
                  placeholder="Please enter a description"
                />
              </Col>
            </Row>
          </SectionWrapper>
          <button onClick={() => handleCreate()}>Create Form</button>
        </FormCard>
      </GeneralStyle>
    </>
  );
};

export default FormsCreation;

FormsCreation.propTypes = {
  setFormTrigger: func.isRequired,
  handleFormCreation: PropTypes.func,
};
